import { Button, Col, Form, Input, Layout, Row, Space, message } from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useContext, useState } from "react";
import CONSTANTS from "constants/constants";
import homeMain from "assets/home-main.svg";
// import aboutUs from "assets/about_company.svg";
// import checkIcon from "assets/check-icon.svg";
import homeProdred from "assets/home-prodred.svg";
import homeHelpImg from "assets/home-need-help-img.svg";
import homeDvt from "assets/home-dvt.svg";
import homeMarketPulse from "assets/home-market-pulse.svg";
import ProdRedDemoVideo from "assets/videos/Prod_red.mp4";
import DVTDemoVideo from "assets/videos/DVT.mp4";
import MarketPulseDemoVideo from "assets/videos/Market_Pulse.mp4";
import "components/OurServices/style.css";
import "components/Home/style.css";
import "components/ContactUs/style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import useWindowDimensions from "utils/WindowDimensions";
import { useNavigate } from "react-router-dom";
import { Context } from "Context";
import DemoVideoModal from "common/DemoVideoModal";
import { PlayIcon } from "common/icons";

const Home = () => {
  const { HOME, CONTACT_US } = CONSTANTS;
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const [messageApi, contextHolder] = message.useMessage();
  const { current, setCurrent } = useContext(Context);
  const [demoVideoDetails, setDemoVideoDetails] = useState({ open: false });
  // const aboutUsValues = [
  //   HOME.HOME_ABOUT_US_VALUES.FIRST,
  //   HOME.HOME_ABOUT_US_VALUES.SECOND,
  //   HOME.HOME_ABOUT_US_VALUES.THIRD,
  // ];

  const onChangeDemoVideo = (view, video = null) => {
    setDemoVideoDetails({ open: view, video });
  };

  return (
    <Layout>
      {contextHolder}
      {demoVideoDetails?.open && (
        <DemoVideoModal
          demoVideoModal={demoVideoDetails?.open}
          onChangeDemoVideo={onChangeDemoVideo}
          demoVideo={demoVideoDetails?.video}
        />
      )}
      <Content>
        <Row
          className="dvt-section pr4 pl4 pb2 pt2 dvt-main"
          justify="space-around"
          align="middle"
          gutter={[0, 24]}
        >
          <Col lg={12}>
            <p className="dvt-section-header mt0">
              <span className="dvt-special-text">Pioneering </span>
              The Future Of
              <span className="dvt-special-text"> Electric Mobility </span>
              Analytics
            </p>
            <p className="dvt-section-text fw-500">
              {HOME.HOME_MAIN_TEXT1}{" "}
              <span className="dvt-special-text">{HOME.HOME_MAIN_TEXT2}</span>
              <span>{HOME.HOME_MAIN_TEXT3}</span>
            </p>
          </Col>
          <Col lg={12} className="flex-center">
            <img src={homeMain} className="dvt-image" alt="dvt hero" />
          </Col>
        </Row>
        {/* <Row
          className="pr4 pl4 pb2 pt2 about-us-main"
          justify="space-around"
          align="middle"
          gutter={[0, 32]}
        >
          <Col lg={{ span: 12, order: 2 }} md={{ order: 1 }}>
            <p className="about-us-section-header mt1">
              <span className="about-us-special-text">About </span>US
            </p>
            <p className="dvt-section-text fw-500">
              {HOME.HOME_ABOUT_US1}
              <span className="dvt-special-text"> {HOME.HOME_ABOUT_US2}</span>
              <span>{HOME.HOME_ABOUT_US3}</span>
            </p>
            <Row gutter={[16]}>
              <Col lg={14}>
                <p className="home-about-us-sub-header">Our Vision</p>
                <p className="home-about-us-sub-text-sec fw-500">
                  {HOME.HOME_ABOUT_US_VISION}
                </p>
              </Col>
              <Col lg={10}>
                <p className="home-about-us-sub-header">Our Values</p>
                <div className="home-about-us-sub-text-sec fw-500">
                  {aboutUsValues.map((item, index) => (
                    <div className="home-about-us-sub-text" key={index}>
                      <span>
                        <img
                          src={checkIcon}
                          alt="check icon"
                          className="about-us-check-icon"
                        />
                      </span>
                      <p className="m0">{item}</p>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
            <Button
              type="primary"
              size="large"
              className="home-main-button fw-500"
              onClick={() => {
                setCurrent("/aboutUs");
                navigate("/aboutUs");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              Learn More
            </Button>
          </Col>
          <Col
            lg={{ span: 12, order: 1 }}
            md={{ order: 2 }}
            className="flex-center"
          >
            <img src={aboutUs} className="about-us-image" alt="about company" />
          </Col>
        </Row> */}
        <Row
          className="pr4 pl4 pb2 pt2 about-us-main"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={24} className="text-center f1">
            <p className="about-us-section-header mt1">
              Our Offerings For
              <span className="about-us-special-text"> EV Analytics</span>
            </p>
            <p className="fw-500 dvt-section-text text-center">
              <span className="dvt-special-text">
                {HOME.HOME_OFFERING_TEXT1}
              </span>
              {HOME.HOME_OFFERING_TEXT2}
            </p>
          </Col>
        </Row>
        <Row
          className="dvt-section pr4 pl4 pb2 pt2 dvt-main"
          justify="space-around"
          align="middle"
          gutter={[0, 32]}
        >
          <Col lg={{ span: 12, order: 2 }} md={{ order: 1 }}>
            <p className="dvt-section-header mt1">
              <span className="dvt-special-text">Prod</span>
              Red
            </p>
            <p className="dvt-section-text fw-500">
              <span>{HOME.HOME_PROD_RED_TEXT}</span>
            </p>
            <Button
              type="primary"
              size="large"
              className="home-main-button fw-500"
              onClick={() => {
                setCurrent("/ourServices/prodRed");
                navigate("/ourServices/prodRed");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              Learn More
            </Button>
          </Col>
          <Col
            className="play-hvr-box flex-center"
            lg={{ span: 12, order: 1 }}
            md={{ order: 2 }}
          >
            <img
              src={homeProdred}
              className="dvt-image img-hvr-play"
              alt="dvt hero"
            />
            <div
              className="img-play-btn"
              onClick={() => onChangeDemoVideo(true, ProdRedDemoVideo)}
            >
              <PlayIcon className="play-btn-icon" />
              <div className="play-btn-text">Quick Tour</div>
            </div>
          </Col>
        </Row>
        <Row
          className="dvt-section pr4 pl4 pb2 pt2 dvt-main"
          justify="space-around"
          align="middle"
          gutter={[0, 32]}
        >
          <Col lg={12}>
            <p className="dvt-section-header mt1">
              <span className="dvt-special-text">DVT</span>
            </p>
            <p className="dvt-section-text fw-500">
              <span>{HOME.HOME_DVT_TEXT}</span>
            </p>
            <Button
              type="primary"
              size="large"
              className="home-main-button fw-500"
              onClick={() => {
                navigate("/ourServices/dvt");
                setCurrent("/ourServices/dvt");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              Learn More
            </Button>
          </Col>
          <Col lg={12} className="dvt-play-img play-hvr-box flex-center">
            <img
              src={homeDvt}
              className="dvt-image img-hvr-play"
              alt="dvt hero"
            />
            <div
              className="img-play-btn"
              onClick={() => onChangeDemoVideo(true, DVTDemoVideo)}
            >
              <PlayIcon className="play-btn-icon" />
              <div className="play-btn-text">Quick Tour</div>
            </div>
          </Col>
        </Row>

        {/* Market Pulse */}
        <Row
          className="dvt-section pr4 pl4 pb2 pt2 dvt-main"
          justify="space-around"
          align="middle"
          gutter={[0, 32]}
        >
          <Col lg={{ span: 12, order: 2 }} md={{ order: 1 }}>
            <p className="dvt-section-header mt1">
              <span className="dvt-special-text">Market Pulse</span>
            </p>
            <p className="dvt-section-text fw-500">
              <span>{HOME.HOME_MARKET_PULSE_TEXT}</span>
            </p>
            <Button
              type="primary"
              size="large"
              className="home-main-button fw-500"
              onClick={() => {
                navigate("/ourServices/marketPulse");
                setCurrent("/ourServices/marketPulse");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              Learn More
            </Button>
          </Col>
          <Col
            lg={{ span: 12, order: 1 }}
            md={{ order: 2 }}
            className="play-hvr-box flex-center"
          >
            <img
              src={homeMarketPulse}
              className="dvt-image img-hvr-play"
              alt="market pulse hero"
            />
            <div
              className="img-play-btn"
              onClick={() => onChangeDemoVideo(true, MarketPulseDemoVideo)}
            >
              <PlayIcon className="play-btn-icon" />
              <div className="play-btn-text">Quick Tour</div>
            </div>
          </Col>
        </Row>
        <Row
          className="dvt-main home-help-main home-help-sec-main"
          align="middle"
          gutter={[]}
          justify="start"
        >
          <Col lg={24} className="">
            {width >= 768 && <Row className="home-need-help-sec1"></Row>}

            <Row className="dvt-main home-need-help-sec2 pr4 pl4 pb2 pt2">
              <Col md={12} lg={15} xl={16}>
                <p className="dvt-section-header mt1">
                  {HOME.HOME_NEED_HELP_HEADER}
                </p>
                <p className="dvt-section-text fw-500">
                  {HOME.HOME_NEED_HELP_TEXT}
                </p>
              </Col>
            </Row>
          </Col>
          {width >= 768 && (
            <img
              src={homeHelpImg}
              className="home-help-sec-img"
              alt="dvt hero"
            />
          )}
        </Row>

        <Row
          className="pr4 pl4 pb2 pt2 contact-us-main"
          justify="space-around"
          align="middle"
        >
          <Col lg={24}>
            <Row justify="space-around">
              <p className="dvt-section-header mt1">
                <span className="contact-us-special-text">Contact</span> Us
              </p>
            </Row>
            <Row justify="space-around" className="mb1">
              <p className="contact-us-form-text fw-500 mt0">
                {CONTACT_US.FORM_TEXT}
              </p>
            </Row>
            <Row gutter={[32, 32]} justify="center">
              <Col lg={24} xl={16} xs={24} sm={24}>
                <div className="zohoBeginFormLayout" style={{ height: "100%" }}>
                  <iframe
                    id="zohoBigin"
                    className="zohoBeginForm"
                    src="https://in.bigin.online/nichesolv777061938/forms/contact-us-ev"
                    style={{ width: "100%", height: "100%" }}
                  ></iframe>
                </div>
              </Col>
              <Col
                lg={12}
                xl={8}
                xs={24}
                sm={18}
                className="contact-us-form-details"
              >
                <Space
                  direction="vertical"
                  size={36}
                  className="contact-us-form-space w100"
                >
                  <div>
                    <Input
                      prefix={<FontAwesomeIcon icon={faLocationDot} />}
                      defaultValue={CONTACT_US.FORM_ADDRESS}
                      className="contact-us-form-details-input"
                    />
                  </div>
                  <div>
                    <Input
                      prefix={<FontAwesomeIcon icon={faEnvelope} />}
                      defaultValue={CONTACT_US.FORM_EMAIL}
                      className="contact-us-form-details-input"
                    />
                  </div>
                  <div>
                    <Input
                      prefix={<FontAwesomeIcon icon={faPhone} />}
                      defaultValue={CONTACT_US.FORM_PHONE}
                      className="contact-us-form-details-input"
                    />
                  </div>
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default Home;
